import script from "./ModalProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalProduct.vue?vue&type=script&lang=ts&setup=true"

import "./ModalProduct.vue?vue&type=style&index=0&id=6e2e5ba2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2e5ba2"]])

export default __exports__